import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash.isempty';
import { selectGradeYear } from '../../../../api/studentSummary/shared/studentSummaryActions';
import { selectors } from '../../../../root/reading/root';
import { LRS_TAB_NAME } from '../../../../constants/shared/LrsConstants';
import LinkWrapper from '../../../../features/navigation/LinkWrapper';
import openProbeDetails from '../../../../api/probeDetails/probeDetailsActions';
import { pmGraphResetZoomEvent, pmGraphZoomEvent } from '../../../../api/lrs/shared/lrsActions';
import Progress from '../../../../features/studentSummary/shared/progress/Progress';
import { fetchBurstResultsForYear } from '../../../../api/results/reading/resultActions';
import ProbeDetailsPageContainer from '../../../probeDetails/reading/ProbeDetailsPageContainer';
import { LICENSE } from '../../../../constants/reading/CommonConstants';
import { getUrlParams } from '../../../../utils/shared/urlUtils';
import { getMeasureTitle } from '../../../../utils/reading/measureUtils';
import { getSpecificReadingGoal, isBurstMeasure } from '../../../../utils/reading/filterUtils';
import { isMeasureEnabledForGradePeriod } from '../../../../utils/reading/tableUtils';
import CommonCellBuilder from '../../../../components/cell/reading/CommonCellBuilder';
import { getGradeYearString } from '../../../../features/studentSummary/shared/common/gradeNavTabs';

const { BURST } = LICENSE;

const mapStateToProps = state => {
    const location = selectors.getLocation(state);

    const selectedStudentId = selectors.getSelectedStudentId(state);
    const yearsStudentResultsFetchedFor = selectors.getYearsStudentResultsFetchedFor(
        state,
        selectedStudentId,
    );
    const licensingInfo = selectors.getLicensingInfo(state);
    const getGradeToMeasureMapper = selectors.getGradeToMeasureMapper(state);
    return {
        location,
        selectedStudentId,
        yearsStudentResultsFetchedFor,
        getGradeToMeasureMapper,
        currentPeriod: selectors.getCurrentPeriod(state),
        windowDates: selectors.getWindowDates(state),
        isCurrentSchoolYear: selectors.isCurrentSchoolYear(state),
        student: selectors.getStudentById(state, selectedStudentId),
        studentDataByMeasures: selectors.getDataByMeasuresForStudentProgress(state),
        licensingInfo,
        selectedGradeYear: selectors.getSelectedGradeYear(state),
        currentSchoolYear: selectors.getCurrentSchoolYear(state),
        gradeYears: selectors.getGradeYears(state),
        isGradeYearsFetching: selectors.isGradeYearsFetching(state),
        getMeasureTitle,
        CommonCellBuilder,
        LinkWrapper,
        toyPeriods: selectors.getToyPeriods(state),
        summerPeriodLabel: selectors.getSummerPeriodLabel(state),
    };
};

const mapDispatchToProps = dispatch => ({
    pmGraphLookerEvent: (measure, studentId) => dispatch(pmGraphZoomEvent(measure, studentId)),
    pmGraphResetZoomEvent: (measure, studentId) =>
        dispatch(pmGraphResetZoomEvent(measure, studentId)),
    openProbeDetails: resultId => dispatch(openProbeDetails(resultId)),
    selectGradeYear: (gradeYearPair, studentId) =>
        dispatch(selectGradeYear(gradeYearPair, studentId, LRS_TAB_NAME.PROGRESS)),
    fetchBurstResultsForYear: (studentId, districtId, schoolId, classId, year, applicationSid) => {
        dispatch(
            fetchBurstResultsForYear(
                studentId,
                districtId,
                schoolId,
                classId,
                year,
                applicationSid,
            ),
        );
    },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const {
        location,
        licensingInfo,
        selectedStudentId,
        currentSchoolYear,
        yearsStudentResultsFetchedFor,
        studentDataByMeasures,
        gradeYears,
        getGradeToMeasureMapper,
    } = stateProps;
    const { district, school, classe, applicationSid, resultId } = getUrlParams(location);

    const isHistoricalBurstResultsNotFetched = year =>
        licensingInfo.includes(BURST) &&
        year !== currentSchoolYear &&
        !yearsStudentResultsFetchedFor.includes(year);

    const fetchHistoricalResults = async gradeYearPair => {
        const year = isEmpty(gradeYearPair)
            ? currentSchoolYear
            : Number(gradeYearPair.split('_')[1]);
        if (isHistoricalBurstResultsNotFetched(year)) {
            await dispatchProps.fetchBurstResultsForYear(
                selectedStudentId,
                district,
                school,
                classe,
                year,
                applicationSid,
            );
        }
    };

    const currentGradeYear =
        !isEmpty(gradeYears) && gradeYears.find(({ year }) => year === currentSchoolYear);
    const defaultGradeYear = currentGradeYear && getGradeYearString(currentGradeYear);

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        studentDataByMeasures,
        isGoalAvailable: (measure, grade, period) =>
            isMeasureEnabledForGradePeriod(measure, grade, period, getGradeToMeasureMapper) ||
            isBurstMeasure(measure),
        isHistoricalResultsNotFetched: isHistoricalBurstResultsNotFetched,
        isDataMeasureExists: (statuses, measure) => !(isEmpty(statuses) && isBurstMeasure(measure)),
        selectGradeYear: gradeYearPair => {
            const gradeYear = gradeYearPair || defaultGradeYear;
            dispatchProps.selectGradeYear(gradeYear, selectedStudentId);
            fetchHistoricalResults(gradeYearPair);
        },
        probeDetailWrapper: <>{resultId && <ProbeDetailsPageContainer resultId={resultId} />}</>,
        getSpecificGoal: getSpecificReadingGoal,
        chartLookerEvent: measure => dispatchProps.pmGraphLookerEvent(measure, selectedStudentId),
        resetZoomLookerEvent: measure =>
            dispatchProps.pmGraphResetZoomEvent(measure, selectedStudentId),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Progress);
